module.exports = __webpack_public_path__ + "static/img/card.2d318941.svg";